export default "/kiban/_next/static/images/longHole-feb39773342cb1692a933ace19a82052.png";